import React, { createContext } from 'react';
import { useNurseForm } from '../hooks/useNurseForm'

export const NurseFormContext = createContext(null);

export const NurseFormContextProvider = ({ children }) => {

    const nurseFormContext = useNurseForm();

    return (
        <NurseFormContext.Provider value={nurseFormContext}>
            {children}
        </NurseFormContext.Provider>
    )
}
